module.exports = __webpack_public_path__ + "img/1-230109144252P8.1c623041.jpg";